module.exports = __webpack_public_path__ + "img/account.b26af13d.png";